import { Paper } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { useAuth } from '@/features/authentication/contexts/AuthContext'
import ResourceSteeringCard from '@/features/resource/components/steering/ResourceSteeringCard'
import { isCentralSteeringConfigVisible } from '@/features/resource/configuration/utils/resourceConfigurationVisibility'
import { ResourceRouteInformation } from '@/features/resource/constants'
import { useResourceData } from '@/features/resource/contexts/ResourceDataContext'
import { useResourceDetails } from '@/features/resource/pages/ResourceDetailsPage'

function ResourceSteeringPage() {
  const { t } = useTranslation()
  const { resourceUuid } = useParams()
  const { resource } = useResourceData()
  const { loggedInUser } = useAuth()

  const { setActivePage } = useResourceDetails()

  const isVisible = isCentralSteeringConfigVisible({
    resource,
    loggedInUser,
  })

  useEffect(() => {
    if (resource && isVisible) {
      setActivePage(ResourceRouteInformation.RESOURCE_STEERING.routePath)
    }
  }, [resource, isVisible, setActivePage])

  if (!resourceUuid) {
    return null
  }

  // Central steering config is hidden for locally-controlled resources — they are steered from
  // resource.json via the Resource configuration tab.
  if (resource && !isVisible) {
    return <Paper sx={{ p: 3, mt: 2 }}>{t('resources.steering.not_applicable_local')}</Paper>
  }

  return <ResourceSteeringCard />
}

export default ResourceSteeringPage
